export function getPriceWithMarkup(ticketPrice, maxTicketPrice) {
    var is_self_paying = localStorage.getItem("is_self_paying");
    const maxPrice = parseFloat(maxTicketPrice);
    const price = parseFloat(ticketPrice);
    const margin = (price < maxPrice) && is_self_paying == 0 ? 0.20 : 0;
    let finalPrice = price * (1 + margin);
    if (finalPrice > maxPrice && price < maxPrice) {
        const halfDifference = (maxPrice - price) / 2;
        finalPrice = price + halfDifference;
    }
    return parseFloat(finalPrice);
}
export function getTotalPriceWithMarkup(travelerPricings, maxTicketPrice) {
    var is_self_paying = localStorage.getItem("is_self_paying");
    var finalPrice = 0;
    travelerPricings.forEach(element => {
        const maxPrice = parseFloat(maxTicketPrice);
        const ticketPrice = parseFloat(element.price.total);
        const margin = (ticketPrice < maxPrice) && is_self_paying == 0 ? 0.20 : 0;
        let price = ticketPrice * (1 + margin);
        if (price > maxPrice && ticketPrice < maxPrice) {
            const halfDifference = (maxPrice - ticketPrice) / 2;
            price = ticketPrice + halfDifference;
        }
        finalPrice += price;
    });
    return (finalPrice);
}